<template>
  <div
    class="w-full max-w-[44rem] mx-auto px-4 sm:px-6 pt-8 lg:pt-12 pb-20 lg:pb-28"
  >
    <h1 class="page-title">신청 확인</h1>
    <p class="mt-2 text-[0.9375rem] text-gray-500">
      신청 내용을 확인한 뒤 결제를 진행해 주세요.
    </p>

    <!-- 신청 내용 -->
    <section class="pay-section" aria-labelledby="register-info-title">
      <h2 id="register-info-title" class="section-title">신청 내용</h2>
      <dl class="info-list">
        <div class="info-row">
          <dt>컨퍼런스</dt>
          <dd class="font-semibold">{{ state.register.title }}</dd>
        </div>
        <div class="info-row">
          <dt>신청자 이름</dt>
          <dd>{{ state.register.name }}</dd>
        </div>
        <div class="info-row">
          <dt>신청자 연락처</dt>
          <dd class="mont">{{ formattedPhone }}</dd>
        </div>
        <div class="info-row">
          <dt>신청자 이메일</dt>
          <dd class="break-all">{{ state.register.email }}</dd>
        </div>
        <div v-if="state.register.headcount" class="info-row">
          <dt>참석 인원</dt>
          <dd>{{ state.register.headcount }}명</dd>
        </div>
      </dl>
    </section>

    <!-- 결제 수단 - pc -->
    <form
      action="https://nodeblack.net/api/pay/pc"
      target="fPayPopForm"
      method="post"
      name="pcPayForm"
      class="pay-section max-[768px]:!hidden"
      aria-labelledby="pc-pay-method-title"
    >
      <input type="hidden" name="idx" v-model="state.register.idx">
      <input type="hidden" v-model="state.register.title" name="goodname">
      <input type="hidden" v-model="state.register.name" name="buyername">
      <input type="hidden" v-model="state.register.phone" name="buyertel">
      <input type="hidden" v-model="state.register.email" name="buyeremail">
      <input type="hidden" v-model="state.register.total_price" name="price">

      <h2 id="pc-pay-method-title" class="section-title">결제 수단</h2>
      <div class="pay-options">
        <label class="pay-option">
          <input
            type="radio"
            name="gopaymethod"
            value="Card"
            v-model="pcPayMethod"
            class="pay-input sr-only"
          >
          <span class="pay-option-box">
            <span class="pay-radio" aria-hidden="true"></span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.6"
              stroke="currentColor"
              class="pay-icon"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
              />
            </svg>
            신용카드
          </span>
        </label>
        <label class="pay-option">
          <input
            type="radio"
            name="gopaymethod"
            value="DirectBank"
            v-model="pcPayMethod"
            class="pay-input sr-only"
          >
          <span class="pay-option-box">
            <span class="pay-radio" aria-hidden="true"></span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.6"
              stroke="currentColor"
              class="pay-icon"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
              />
            </svg>
            실시간 계좌이체
          </span>
        </label>
<!--        <label class="pay-option">
          <input type="radio" name="gopaymethod" value="VBank" v-model="pcPayMethod" class="pay-input sr-only">
          <span class="pay-option-box">가상계좌(무통장입금)</span>
        </label>-->
      </div>
    </form>

    <!-- 결제 수단 - mobile -->
    <form
      action="https://nodeblack.net/api/pay/mobile"
      method="POST"
      name="mPayForm"
      class="pay-section hidden max-[768px]:!block"
      aria-labelledby="m-pay-method-title"
    >
      <input type="hidden" name="idx" v-model="state.register.idx">
      <input type="hidden" name="goodname" v-model="state.register.title">
      <input type="hidden" name="buyername" v-model="state.register.name">
      <input type="hidden" name="price" v-model="state.register.total_price">

      <h2 id="m-pay-method-title" class="section-title">결제 수단</h2>
      <div class="pay-options">
        <label class="pay-option">
          <input
            type="radio"
            name="gopaymethod"
            value="CARD"
            v-model="mPayMethod"
            class="pay-input sr-only"
          >
          <span class="pay-option-box">
            <span class="pay-radio" aria-hidden="true"></span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.6"
              stroke="currentColor"
              class="pay-icon"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
              />
            </svg>
            신용카드
          </span>
        </label>
        <label class="pay-option">
          <input
            type="radio"
            name="gopaymethod"
            value="BANK"
            v-model="mPayMethod"
            class="pay-input sr-only"
          >
          <span class="pay-option-box">
            <span class="pay-radio" aria-hidden="true"></span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.6"
              stroke="currentColor"
              class="pay-icon"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
              />
            </svg>
            실시간 계좌이체
          </span>
        </label>
<!--        <label class="pay-option">
          <input type="radio" name="gopaymethod" value="VBANK" v-model="mPayMethod" class="pay-input sr-only">
          <span class="pay-option-box">가상계좌(무통장입금)</span>
        </label>-->
      </div>
    </form>

<!--      <div v-show="is_show" class="modal">-->
<!--        <iframe name="fPayForm" style="display: block; width: 100vw; height: 100vh; position: fixed; left: 0; top: 0;"></iframe>-->
<!--      </div>-->

    <!-- 결제 금액 -->
    <div class="total-box">
      <span class="text-[0.9375rem] font-semibold text-gray-700">결제 금액</span>
      <span class="total-price">
        <span class="mont">{{ formattedPrice }}</span>원
      </span>
    </div>

    <!-- pc -->
    <button
      type="button"
      class="pay-button flex max-[768px]:!hidden"
      @click="pcPaySubmit"
    >
      {{ formattedPrice }}원 결제하기
    </button>

    <!-- mobile -->
    <button
      type="button"
      class="pay-button hidden max-[768px]:!flex"
      @click="mPaySubmit"
    >
      {{ formattedPrice }}원 결제하기
    </button>
  </div>
<!--  <button @click="limitCheck">t</button>-->
</template>

<script>
import { useRoute } from 'vue-router'
import { reactive } from 'vue'
import axios from 'axios'
import router from "@/router";
import { numberWithCommas } from "@/assets/js/util.js";

export default {
  name: "EduListRegisterPage",
  data: () => {
    return {
      is_show: false,
      // 결제 수단 - pc(이니시스 웹표준)와 mobile 의 값이 달라 따로 둔다. 기본은 신용카드
      pcPayMethod: 'Card',
      mPayMethod: 'CARD'
    }
  },
  computed: {
    // 010-1234-5678
    formattedPhone() {
      const phone = this.state.register.phone ?? ''
      return phone.replace(/^(\d{3})(\d{3,4})(\d{4})$/, '$1-$2-$3')
    },
    formattedPrice() {
      return numberWithCommas(Number(this.state.register.total_price) || 0)
    }
  },

  setup () {
    const route = useRoute()

    const state = reactive({
      register: [{
        memberList: [{

        }]
      }],

    })

    const idx = route.params.idx
    
    const load = () => {
      axios.get('/api/registered/conference/pay/' + idx).then(response => {
        if (response.data.err_code === 0) {
          state.register = response.data.contents
          if( state.register.conf_detail_idx === 57 ){
            state.register.title = '겨울성경학교.수련회 온라인 컨퍼런스 1차 (2023/12/11 19:00)';
          }
          else if( state.register.conf_detail_idx === 58 ){
            state.register.title = '겨울성경학교.수련회 온라인 컨퍼런스 2차 (2024/01/06 10:00)';
          }
        } else {
          router.push({path: '/'})
          alert(response.data.err_msg)
        }
        
      }).catch(error => {
        console.error(error)
      })
    }
    
    load()
    
    return { state }
  },
  methods: {
    async pcPaySubmit() {
      // window.open('','fPayPopForm','width=900,height=700');
      // document.pcPayForm.submit();
      const url = `/api/payment/check-limit/${this.state.register.conf_detail_idx}?headcount=${this.state.register.headcount}`;
      const { status, data } = await axios.get(url);
      if( status === 200 ){
        if( data.err_code === 0 ){
          window.open('','fPayPopForm','width=900,height=700');
          document.pcPayForm.submit();
        }
        else if( data.err_code === 403 ){
          alert(data.err_msg);
          document.location.reload();
        }
        else {
          alert('새로고침 후 다시 시도 해 주세요.');
          document.location.reload();
        }
      }
      else {
        alert('새로고침 후 다시 시도 해 주세요.');
        document.location.reload();
      }

      /*
      if( response.data.err_code === 0 ){
        // window.open('','fPayPopForm','width=900,height=700');
        // document.pcPayForm.submit();
      }
      else {
        alert(response.data.err_msg);
        return false;
      }
      */
    },
    async mPaySubmit() {
      // document.mPayForm.submit();
      const url = `/api/payment/check-limit/${this.state.register.conf_detail_idx}?headcount=${this.state.register.headcount}`;
      const { status, data } = await axios.get(url);
      if( status === 200 ){
        if( data.err_code === 0 ){
          document.mPayForm.submit();
        }
        else if( data.err_code === 403 ){
          // alert(data.err_msg);
          alert('신청 인원 다 차서 신청이 마감 되었습니다. 감사합니다.');
          document.location.reload();
        }
        else {
          alert('새로고침 후 다시 시도 해 주세요.');
          document.location.reload();
        }
      }
      else {
        alert('새로고침 후 다시 시도 해 주세요.');
        document.location.reload();
      }
      /*
      if( response.data.err_code === 0 ){
          document.mPayForm.submit();
      }
      else {
        alert(response.data.err_msg);
        return false;
      }
       */
    },
    async limitCheck() {
      const url = `/api/payment/check-limit/${this.state.register.conf_detail_idx}?headcount=${this.state.register.headcount}`;
      const response = await axios.get(url);
      console.log(response);
      console.log(response.data);
    }
  }
}
</script>

<style scoped>
.page-title {
  @apply text-2xl md:text-[2rem] font-bold tracking-tight text-gray-900;
}

.pay-section {
  @apply mt-6 rounded-2xl border border-gray-200 bg-white p-5 md:p-8;
}

.section-title {
  @apply text-lg md:text-xl font-bold tracking-tight text-gray-900;
}

/* 신청 내용 */
.info-list {
  @apply mt-4 divide-y divide-gray-100;
}

.info-row {
  @apply grid gap-1 py-3.5 sm:grid-cols-[8rem_minmax(0,1fr)] sm:gap-6;
}

.info-row:last-child {
  @apply pb-0;
}

.info-row dt {
  @apply text-sm text-gray-500 sm:pt-px;
}

.info-row dd {
  @apply text-[0.9375rem] text-gray-900 break-keep;
}

/* 결제 수단 */
.pay-options {
  @apply mt-4 grid gap-3 sm:grid-cols-2;
}

.pay-option {
  @apply block cursor-pointer;
}

.pay-option-box {
  @apply flex h-16 items-center gap-3 rounded-xl border border-gray-300 bg-white px-4 text-[0.9375rem] font-semibold text-gray-700 transition-colors hover:border-gray-400;
}

.pay-icon {
  @apply h-6 w-6 shrink-0 text-gray-400 transition-colors;
}

.pay-radio {
  @apply h-5 w-5 shrink-0 rounded-full border-2 border-gray-300 bg-white transition;
}

.pay-input:checked + .pay-option-box {
  @apply border-main-navy bg-main-navy/5 text-main-navy ring-1 ring-main-navy;
}

.pay-input:checked + .pay-option-box .pay-icon {
  @apply text-main-navy;
}

.pay-input:checked + .pay-option-box .pay-radio {
  @apply border-[6px] border-main-navy;
}

.pay-input:focus-visible + .pay-option-box {
  @apply ring-4 ring-main-navy/20;
}

/* 결제 금액 */
.total-box {
  @apply mt-6 flex items-center justify-between gap-4 rounded-2xl bg-slate-50 px-5 py-5 md:px-8;
}

.total-price {
  @apply text-2xl md:text-[1.75rem] font-bold tracking-tight text-main-navy;
}

.pay-button {
  @apply mt-6 h-14 w-full items-center justify-center rounded-xl bg-main-navy text-base md:text-lg font-bold text-white shadow-sm transition-colors hover:bg-main-navy/90 focus:outline-none focus-visible:ring-4 focus-visible:ring-main-navy/30;
}
</style>
